import { apiOrdersGateway } from './api/orders.gateway';
import { fakeOrdersGateway } from './fake/orders.gateway';
import type { PdsOrdersGateway } from './gateway';
import { usesFakeData } from './mode';

export const resolveGateway = (): PdsOrdersGateway =>
  usesFakeData() ? fakeOrdersGateway : apiOrdersGateway;
